const stores = [
    {
        "id": 1,
        "name": "VADAPALANI",
        "address": "No.27/8, Arcot Road, Vadapalani, Chennai-26",
        "area": "Vadapalani, Chennai-600026",
        "mobile": "9884800208",
        "phone": "24843152"
    },
    {
        "id": 2,
        "name": "K K Nagar",
        "address": "No.100/A5, Ponnambalam Salai, K.K.Nagar, Chennai-78",
        "area": "K.K Nagar, Chennai-600078",
        "mobile": "9884002024",
        "phone": ""
    },
    {
        "id": 3,
        "name": "Ashok Nagar",
        "address": "No.24, 10th Avenue, Ashok Pillar, Chennai-83",
        "area": "Ashok Nagar, Chennai-600083",
        "mobile": "9884800202",
        "phone": ""
    },
    {
        "id": 4,
        "name": "Kamarajar Salai",
        "address": "No.9, Kamarajar Salai, Ashok Nagar, Chennai-83",
        "area": "Kamarajar Salai, Chennai-600083",
        "mobile": "9884902225",
        "phone": "23624664"
    },
    {
        "id": 5,
        "name": "Valasaravakkam",
        "address": "No.27, Arcot Road, Valasaravakkam, Chennai-87",
        "area": "Valasaravakkam, Chennai-600087",
        "mobile": "9884800208",
        "phone": "24868163"
    },
    {
        "id": 6,
        "name": "Kodambakkam",
        "address": "No.88, Dr. Ambedkar Road, Kodambakkam, Chennai-24",
        "area": "Kodambakkam, Chennai-600024",
        "mobile": "9884902224",
        "phone": "45588208,24841224"
    },
    {
        "id": 7,
        "name": "MMDA",
        "address": "No.1-138, Vinayagapuram Main Road, MMDA Colony, Arumbakkam, Chennai-106",
        "area": "Arumbakkam, Chennai-600106",
        "mobile": "9627578555",
        "phone": ""
    },
    {
        "id": 8,
        "name": "PORUR",
        "address": "No.64B, Arcot Road, Porur, Chennai-116",
        "area": "Porur, Chennai-600116",
        "mobile": "9176552525",
        "phone": ""
    },
    {
        "id": 9,
        "name": "KILPAUK",
        "address": "No.75, Ormes Road, Kilpauk, Chennai-10",
        "area": "Kilpauk, Chennai-600010",
        "mobile": "9952494999",
        "phone": "42123450,42174960"
    },
    {
        "id": 10,
        "name": "VILLIVAKKAM",
        "address": "No.5, Janakiram Reddy Colony, Villivakkam, Chennai-49",
        "area": "Villivakkam, Chennai-600049",
        "mobile": "9095234555",
        "phone": ""
    },
    {
        "id": 11,
        "name": "Alapakkam",
        "address": "No.11, Sundar Nagar, Alapakkam Main Road, Maduravoyal, Chennai-95",
        "area": "Alapakkam, Chennai-600095",
        "mobile": "9095234111",
        "phone": "24760411"
    },
    {
        "id": 12,
        "name": "MTH Road Villivakkam",
        "address": "No.168, MTH Road, Villivakkam, Chennai-49",
        "area": "MTH Road, Villivakkam, Chennai-600049",
        "mobile": "9095789333",
        "phone": ""
    },
    {
        "id": 13,
        "name": "Mugalivakkam",
        "address": "No.10, Mugalivakkam Main Road, Porur, Chennai-116",
        "area": "Mugalivakkam, Chennai-600125",
        "mobile": "9095789999",
        "phone": ""
    },
    {
        "id": 14,
        "name": "ADAMBAKKAM",
        "address": "No.51, Ground Floor, Vellalar Street, Adambakkam, Chennai-600088",
        "area": "Adambakkam, Chennai-600088",
        "mobile": "9095789222",
        "phone": ""
    },
    {
        "id": 15,
        "name": "AMBATTUR",
        "address": "No.-36, Cholapuram Main Road, Ambattur, Chennai-600053",
        "area": "Ambattur Industrial Estate, Chennai-600058",
        "mobile": "9095789111",
        "phone": ""
    },
    {
        "id": 16,
        "name": "IYYAPPANTHANGAL",
        "address": "Old No.255, New No.17 Mount, Poonamallee Trunk Road, Iyyappanthangal, Chennai-600056",
        "area": "Iyyappanthangal, Chennai-600056",
        "mobile": "9361807509",
        "phone": ""
    },
    {
        "id": 17,
        "name": "North Avadi/Thiruninravur",
        "address": "No.2/7, Sivanthirayar Koil Street, Avadi, Chennai-67",
        "area": "North Avadi, Chennai-600067",
        "mobile": "9095544777",
        "phone": ""
    },
    {
        "id": 18,
        "name": "Ramapuram Thiruvalluvar Salai",
        "address": "No.5/3, Thiruvalluvar Salai, RAMAPURAM, Chennai",
        "area": "Ramapuram, Chennai-600089",
        "mobile": "9095534333",
        "phone": ""
    },
    {
        "id": 19,
        "name": "AMBATTUR VENKATAPURAM",
        "address": "No.18, North Park Street, Venkatapuram, Ambattur, Chennai-600053",
        "area": "Ambattur, Chennai-600053",
        "mobile": "9095534666",
        "phone": ""
    },
    {
        "id": 20,
        "name": "MOGAPPAIR",
        "address": "Old No.255, Mogappair East, Chennai-600037",
        "area": "Mogappair East, Chennai-600037",
        "mobile": "9095544888",
        "phone": ""
    },
    {
        "id": 21,
        "name": "Oil Mill Road Iyyappanthangal",
        "address": "No.6, Ane salai, Oil Mill Road, Iyyappanthangal, Chennai-600056",
        "area": "Oil Mill Road, Iyyappanthangal, Chennai-600056",
        "mobile": "9095334222",
        "phone": "4446588822"
    },
    {
        "id": 22,
        "name": "Kolapakkam",
        "address": "No.4, Jayvary Nagar, Kolapakkam, Chennai-600122",
        "area": "Kolapakkam, Tiruvallur-600127",
        "mobile": "9095834999",
        "phone": ""
    },
    {
        "id": 23,
        "name": "Gerugambakkam",
        "address": "No.448, Kundrathur Main Road, Gerugambakkam, Chennai-600122",
        "area": "Gerugambakkam, Chennai-600122",
        "mobile": "9095243333",
        "phone": ""
    },
    {
        "id": 24,
        "name": "Avadi",
        "address": "115/172, Poonamallee High Road, Avadi, Chennai-600054",
        "area": "Avadi, Chennai-600054",
        "mobile": "9499004333",
        "phone": ""
    },
    {
        "id": 25,
        "name": "Avadi-2",
        "address": "No.47, Kamarajar Nagar Main Road, Avadi-2, Chennai-600071",
        "area": "Kamarajar Nagar, Avadi, Chennai-600071",
        "mobile": "9499003366",
        "phone": ""
    },
    {
        "id": 26,
        "name": "Madha Nagar",
        "address": "No.11, Madha Nagar Extension, Madanandapuram, Chennai-600125",
        "area": "Madanandapuram, Chennai-600125",
        "mobile": "9499002288",
        "phone": ""
    },
    {
        "id": 27,
        "name": "Mandaveli",
        "address": "No.174/176, Ramakrishna Mutt Road, Raja Annamalaipuram, Chennai-600028",
        "area": "Raja Annamalaipuram, Chennai-600028",
        "mobile": "9499004488",
        "phone": ""
    },
    {
        "id": 28,
        "name": "Kolathur",
        "address": "Plot No.15, S.No 1/19, Krishna Nagar 1st Street, Vivekananda Nagar Main Road, Kolathur, Chennai-600099",
        "area": "Kolathur, Tiruvallur-600099",
        "mobile": "9499005544",
        "phone": ""
    },
    {
        "id": 29,
        "name": "Thiruvika Nagar Perambur",
        "address": "Door No.6A, S.R.P Kovil Street North, Thiru Vi Ka Nagar, Perambur, Chennai-600082",
        "area": "T.V.K Nagar, Chennai-600082",
        "mobile": "9093004222",
        "phone": ""
    },
    {
        "id": 30,
        "name": "Saligramam",
        "address": "No.64/1, Arcot Road, Saligramam, Chennai-600093",
        "area": "Saligramam, Chennai-600093",
        "mobile": "9093005333",
        "phone": ""
    },
    {
        "id": 31,
        "name": "Kundrathur",
        "address": "No.5/1, Murugan Koil Main Road, Kundrathur, Chennai-600069",
        "area": "Kundrathur, Chennai-600069",
        "mobile": "9093004333",
        "phone": ""
    }
];

const StoreList = () => {
    return (

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {stores.map((store) => (
                <div key={store.id} className="bg-white p-6 rounded-lg border border-gray-200">
                    <div className="space-y-2">
                        <h3 className="text-lg font-bold text-blue-600">{store.id}. {store.name}</h3>
                        <p className="text-sm text-gray-600">{store.address}</p>
                        <p className="text-sm text-gray-600">{store.area}</p>
                        <div className="pt-2">
                            <p className="text-sm">
                                <span className="font-semibold">Mobile No: </span>
                                {store.mobile}
                            </p>
                            {store.phone && (
                                <p className="text-sm">
                                    <span className="font-semibold">Phone No: </span>
                                    {store.phone}
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default StoreList;